import React from "react";
import { useTranslation } from "react-i18next";
import PageTemplate from "./PageTemplate";
import { pages } from "../../../pages";
import { useGetLang } from "../../hooks/useGetLang";

type Language = "is" | "en";

export const translations = {
  is: {
    loginError: {
      title: "Innskráning mistókst",
      description: "Villa í innskráningu",
      message: "Eitthvað fór úrskeiðis við innskráningu.",
      suggestion: "Gæti verið að þú hefur ekki stofnað aðgang?",
      signUpLink: "Stofna aðgang",
    },
  },
  en: {
    loginError: {
      title: "Login Failed",
      description: "Login error",
      message: "Something went wrong when you logged in.",
      suggestion: "Is it possible that you haven't signed up yet?",
      signUpLink: "Sign Up",
    },
  },
};

const LoginError: React.FC = () => {
  const { t } = useTranslation();
  const lang = useGetLang() as Language;
  const registrationPath = pages[lang].Registration;

  return (
    <PageTemplate
      title={t("loginError.title")}
      url="/login-error"
      description={t("loginError.description")}
      keywords={["login", "error", "urdarbrunnur", "okuskoli"]}
      includeTextContainer={false}
    >
      <div className="login-error-container">
        <h1>{t("loginError.title")}</h1>
        <p>{t("loginError.message")}</p>
        <p>{t("loginError.suggestion")}</p>
        <a href={registrationPath} className="btn">
          {t("loginError.signUpLink")}
        </a>
      </div>
    </PageTemplate>
  );
};

export default LoginError;
